import React from "react";

const categories = [
  { id: "cricket", icon: "🏏", title: "Cricket" },
  { id: "football", icon: "⚽", title: "Football" },
  { id: "badminton", icon: "🏸", title: "Badminton" },
  { id: "movies", icon: "🎬", title: "Movies" },
  { id: "songs", icon: "🎵", title: "Songs" },
  { id: "singers", icon: "🎤", title: "Singers" },
  { id: "actors", icon: "🎭", title: "Actors" },
  { id: "food", icon: "🍕", title: "Food" },
  { id: "restaurants", icon: "🍽️", title: "Restaurants" },
  { id: "books", icon: "📚", title: "Books" },
  { id: "teachers", icon: "👨‍🏫", title: "Teachers" },
  { id: "colleges", icon: "🎓", title: "Colleges" },
  { id: "apps", icon: "📱", title: "Apps" },
  { id: "games", icon: "🎮", title: "Games" },
  { id: "cars", icon: "🚗", title: "Cars" },
  { id: "tourism", icon: "📍", title: "Tourist Places" },
  { id: "brands", icon: "🛍️", title: "Brands" },
  { id: "leaders", icon: "👑", title: "Public Figures" },
  { id: "business", icon: "❤️", title: "Local Business" },
  { id: "pregnancy", icon: "🤰", title: "Pregnancy" },
  { id: "others", icon: "✨", title: "Others" },
];

const FanRatingsCategoryGrid = ({ onBack, onCategorySelected }) => {
  return (
    <div>
      <button
        onClick={onBack}
        className="mb-3 w-fit px-3 py-2 rounded-lg bg-fuchsia-700 hover:bg-fuchsia-600 text-white text-xs font-semibold"
      >
        ← Back
      </button>

      <div className="bg-purple-900 rounded-xl border border-fuchsia-700 p-4">
        <h2 className="text-lg font-bold text-gray-50">🎯 Select Category</h2>

        <p className="text-xs text-gray-100 mt-1">
          Choose a category to view available Fan Rating campaigns.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3 mt-4">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => onCategorySelected(cat)}
            className="rounded-xl bg-purple-800 hover:bg-fuchsia-700 border border-fuchsia-700 p-4 transition duration-200 hover:scale-105"
          >
            <div className="text-4xl text-center">{cat.icon}</div>

            <h3 className="mt-3 text-xs md:text-sm font-semibold text-gray-50 text-center">
              {cat.title}
            </h3>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FanRatingsCategoryGrid;
